export default __webpack_public_path__ + "static/media/pause-white.e921056b.svg";